import fieldType from './fieldType';

/* @private */
const filterGroup = dom => !!dom.checked;
const mapValues = dom => dom.value;

/**
 * @public
 * Gets the value of a field, regardless of its type.
 *
 * @param  {Element} field: any form field (select, input, radio, checkbox, etc.)
 * @return {String|Array}
 */
export default function getFieldValue(field) {
  if (fieldType.isSelectable(field)) {
    return field.options[field.selectedIndex].value;
  }
  if (fieldType.isCheckable(field)) {
    const name = field.name;
    const group = Array.prototype.slice.call(field.form.querySelectorAll(`[name="${name}"]`));
    const checked = group.filter(filterGroup);
    if (!checked.length) return '';
    if (checked.length > 1) return checked.map(mapValues);
    return checked[0].value;
  }
  return field.value || '';
}
